// [CASH-MODE] Shows UPI vs Cash totals side by side.
// `totals` = { UPI: { count, amount }, CASH: { count, amount } } (API `totalsByMode` or totalsByModeFromRows)
// `amountKey` picks which sum to show when the object has several (e.g. 'totalIncome').
import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

const fmt = (n) => `₹${(Number(n) || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const PaymentModeTotals = ({ totals, amountKey = 'amount', title, sx }) => {
  if (!totals) return null;
  const items = [
    { key: 'UPI', label: 'UPI', color: 'primary.main' },
    { key: 'CASH', label: 'Cash', color: 'warning.main' },
  ];
  return (
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', my: 1, ...sx }}>
      {items.map(({ key, label, color }) => {
        const t = totals[key] || {};
        return (
          <Paper key={key} variant="outlined" sx={{ px: 2, py: 1, minWidth: 180, borderLeft: 4, borderLeftColor: color }}>
            <Typography variant="caption" color="text.secondary">{title ? `${title} · ${label}` : label}</Typography>
            <Typography variant="h6" sx={{ lineHeight: 1.3 }}>{fmt(t[amountKey])}</Typography>
            {typeof t.count === 'number' && (
              <Typography variant="caption" color="text.secondary">{t.count} transaction{t.count === 1 ? '' : 's'}</Typography>
            )}
          </Paper>
        );
      })}
    </Box>
  );
};

export default PaymentModeTotals;
